import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from '../../shared/modals/modal.component';

import {
  hideChartModalForDelete,
  deleteChart,
} from './store/actions';
import { isDeletingChartInProgressSelector } from './store/selectors';
import { requiredWhenPresent } from '../../shared/propTypes';

class DeleteChartModal extends PureComponent {
  static propTypes = {
    hideChartModalForDelete: PropTypes.func.isRequired,
    deleteChart: PropTypes.func.isRequired,
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    entityToRemove: requiredWhenPresent(['isVisible'], PropTypes.shape({
      value: PropTypes.string.isRequired,
    }).isRequired),
    canModify: PropTypes.bool,
    isVisible: PropTypes.bool,
    isDeletingInProgress: PropTypes.bool,
  };

  removeChart = () => {
    const {
      deleteChart,
      period,
      entityToRemove: chartName,
      canModify,
    } = this.props;

    deleteChart({
      period,
      chartName,
      canModify,
    });
  };

  render() {
    const {
      hideChartModalForDelete,
      period,
      entityToRemove,
      isVisible,
      isDeletingInProgress,
    } = this.props;

    return (
      <Modal
        className="delete-chart-modal"
        dismissText="Cancel"
        submitText="Yes"
        title="Delete Chart"
        closeAction={hideChartModalForDelete}
        dismissAction={hideChartModalForDelete}
        submitAction={this.removeChart}
        isVisible={isVisible}
        isSubmitting={isDeletingInProgress}
      >
        {
          entityToRemove
            ? (
              <div>
                Are you sure you want to delete: <br/><br/>
                Chart Name: {entityToRemove.value}<br/>
                Period: {period.name}<br/><br/>
              </div>
            )
            : null
        }
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  isDeletingInProgress: isDeletingChartInProgressSelector(state),
});

export default connect(
  mapStateToProps,
  {
    hideChartModalForDelete,
    deleteChart,
  }
)(DeleteChartModal);
